const apiUrl = process.env.REACT_APP_API_URL;

export async function getProducts() {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/products`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  return res.json();
}

export async function createProduct(product) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/products`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(product),
  });
  return res.json();
}

// Business Settings API
export async function getBusinessSettings() {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/business-settings`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  return res.json();
}

export async function saveBusinessSettings(settings) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/business-settings`, {
    method: 'POST',
    headers: { 
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify(settings),
  });
  return res.json();
}

// PDF Management API
export async function uploadPdf(pdfBlob, filename, documentId = null, documentType = 'dnote') {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }

  const formData = new FormData();
  formData.append('file', pdfBlob, filename);

  const url = new URL(`${apiUrl}/upload-pdf`);
  if (documentId) {
    if (documentType === 'invoices') {
      url.searchParams.append('invoice_id', documentId);
    } else {
      url.searchParams.append('dnote_id', documentId);
    }
  }
  // Add document type parameter for proper folder organization
  url.searchParams.append('document_type', documentType);

  const res = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Upload failed');
  }

  return res.json();
}

export async function listPdfs() {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/list-pdfs`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Failed to list PDFs');
  }

  return res.json();
}

export async function downloadPdf(filename) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/download-pdf/${encodeURIComponent(filename)}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Download failed');
  }

  return res.blob();
}

export async function deletePdf(filename) {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Authentication required');
  }
  
  const res = await fetch(`${apiUrl}/delete-pdf/${encodeURIComponent(filename)}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!res.ok) {
    const error = await res.json();
    throw new Error(error.error || 'Delete failed');
  }

  return res.json();
}
